const dropdownAlgolia = function( autocompleteInstance = window.autocompleteInstance ) {

  const searchInputElements = document.querySelectorAll("#Search-In-Modal")
  const mainContentElement = document.getElementById("MainContent")
  const footerElement = document.getElementById("shopify-section-footer")
  const mobileSearchHandlerElement = document.getElementById("mobile-search-handler")
  const searchCloseHandlerElements = document.querySelectorAll("#search-close-handler")
  const searchBoxWrapperElements = document.querySelectorAll("#search-box-wrapper")
  const topSuggestionsHandlerElements = document.getElementsByClassName("js-top-suggestions-handler")
  const headerSearchInput = document.querySelector('.header__search-input')

  if( !searchInputElements ||
    !mainContentElement ||
    !footerElement ||
    !mobileSearchHandlerElement ||
    !searchCloseHandlerElements ||
    !searchBoxWrapperElements ||
    autocompleteInstance.length <= 0 ||
    !topSuggestionsHandlerElements.length
  ) return

  let dropDownMenuIsOpen = false
  const hideDropdownOnscrollResolution = 990

  autocompleteInstance.on('autocomplete:shown', function() {
    dropDownMenuIsOpen = true

    searchBoxWrapperElements.forEach(el => el.classList.add("is-active"));
    document.documentElement.classList.add("search-dropdown-is-open")

    if( mainContentElement ) {
      mainContentElement.classList.add("blur-effect-layer")
    }
    if( footerElement ) {
      footerElement.classList.add("blur-effect-layer")
    }
  })

  autocompleteInstance.on('autocomplete:closed', function() {
    dropDownMenuIsOpen = false

    searchBoxWrapperElements.forEach(el => el.classList.remove("is-active"));
    document.documentElement.classList.remove("search-dropdown-is-open")
    // searchInputElement.value = '';
    autocompleteInstance.autocomplete.setVal("")
    searchInputElements.forEach(el => el.blur());

    if( mainContentElement ) {
      mainContentElement.classList.remove("blur-effect-layer")
    }
    if( footerElement ) {
      footerElement.classList.remove("blur-effect-layer")
    }
  })

  mobileSearchHandlerElement.addEventListener("click", () => {
    if( searchBoxWrapperElements.filter(el => el.classList.contains("is-active")).length > 0 ) return
    autocompleteInstance.autocomplete.open()
  })
  searchCloseHandlerElements.forEach(el => el.addEventListener("click", () => {
    if (window.innerWidth < 990 && el.parentElement.querySelector("#Search-In-Modal").value === '') {
      document.querySelector('html').classList.contains('search-dropdown-is-open') && document.querySelector('html').classList.remove('search-dropdown-is-open');
      document.querySelectorAll('.blur-effect-layer').forEach(el => el.classList.remove('blur-effect-layer'));
      document.querySelector(".header__mobile-search #search-box-wrapper").classList.contains('is-active') && document.querySelector(".header__mobile-search #search-box-wrapper").classList.remove('is-active');
    }
    autocompleteInstance.autocomplete.setVal("");
    autocompleteInstance.autocomplete.close();
  }));

  for (let suggestion of topSuggestionsHandlerElements) {
    suggestion.addEventListener("click", () => {
      autocompleteInstance.autocomplete.setVal(suggestion.getAttribute("data-value"));
      headerSearchInput.focus();
    })
  }

  function hitSuggestion(){
    for (let suggestion of topSuggestionsHandlerElements) {
      if(Array.from(searchInputElements).filter(el => (el.value.toLowerCase() === suggestion.getAttribute("data-value").toLowerCase())).length > 0) {
        suggestion.classList.add("is-active")
      } else {
        suggestion.classList.remove("is-active")
      }
    }
  }

  for (let suggestion of topSuggestionsHandlerElements) {
    suggestion.addEventListener("click", hitSuggestion)
  }

  ["keyup", "change", "focus"].forEach( event => {
    searchInputElements.forEach(el => el.addEventListener(event, hitSuggestion))
  })

}

dropdownAlgolia( window.autocompleteInstance )
